"use client";

import { SidebarGroup, SidebarMenu } from "@/components/ui/sidebar";
import { CollapsibleItem, type NavAreaItem } from "./NavItems";

export function PrimaryNav({ items }: { items: NavAreaItem[] }) {
	return (
		<SidebarGroup>
			<SidebarMenu>
				{items.map((item) => (
					<CollapsibleItem item={item} key={item.title} />
				))}
			</SidebarMenu>
		</SidebarGroup>
	);
}
